import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.string.starts-with.js";
import getConfig from 'next/config';
import Cookies from 'js-cookie';
var clearCognitoCookies = function clearCognitoCookies() {
  var domainName = getConfig().publicRuntimeConfig.domainName;
  var allCookieKeys = Object.keys(Cookies.get());
  var cognitoCookieKeys = allCookieKeys.filter(function (key) {
    return key.startsWith('CognitoIdentityServiceProvider.');
  });
  cognitoCookieKeys.forEach(function (key) {
    Cookies.remove(key, {
      domain: domainName,
      path: '/',
      secure: true,
      sameSite: 'Strict'
    });
  });
};
export default clearCognitoCookies;